import { useMemo } from "react";
import usePermissions from "./usePermissions";

const useSortedPaymentLocations = () => {
  const { permissions } = usePermissions();
  const sortedLocations = useMemo(() => {
    const locations = JSON.parse(permissions)?.payment_location?.locations;
    if (!locations || !locations?.length) {
      return [];
    }
    return [...locations].filter((location) => location.is_active).sort((a, b) => a.label.localeCompare(b.label));
  }, [permissions]);

  return sortedLocations;
};

export default useSortedPaymentLocations;
